import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService } from "../../../shared/providers"
import { ApiResponse } from "../models";
import { ApiResponseBuilder } from "./apiResponseBuilder";
import { BaseController } from './baseController';

@Injectable()
export class AppController extends BaseController {

  public reloadCacheUrl = "api/settings/reloadCaches";
  public reloadUserCacheUrl = "api/settings/reloadUserCaches";
    
  constructor(
    public httpService: HttpService,
    public apiResponseBuilder: ApiResponseBuilder,
  ) {
    super(httpService, apiResponseBuilder);
  }

  public normalizeData = map((response, index) => this.apiResponseBuilder.build(response));

  reloadCaches(userDataOnly: boolean = false) {
    let url = this.reloadCacheUrl;
    if (userDataOnly)
      url = this.reloadUserCacheUrl;

    return this.getData(url, null);
  }

  public getData(url: string, params: any): Observable<ApiResponse> {
    return this.httpService.get(url, params).pipe(this.normalizeData);
  }

  public postData(url: string, params: any): Observable<ApiResponse> {
    return this.httpService.post(url, params).pipe(this.normalizeData);
  }

  public getControllerUrl(): string {
    return "api/settings";
  }

}